import { Link } from 'react-router-dom';
import { Shell } from '../components/Layout.js';
import { useDocumentMeta } from '../lib/document-meta.js';
import { useT } from '../state/i18n.js';

export function NotFoundPage(): JSX.Element {
  const t = useT();
  useDocumentMeta({ title: t({ ko: '페이지를 찾을 수 없음', en: 'Page not found' }), noindex: true });
  return (
    <Shell>
      <article className="not-found">
        <h1>{t({ ko: '페이지를 찾을 수 없습니다', en: 'Page not found' })}</h1>
        <p>
          <Link to="/">{t({ ko: '홈으로 돌아가기', en: 'Back to the landing page' })}</Link>
        </p>
      </article>
    </Shell>
  );
}
